import React from 'react'
import { string } from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames/bind'

import ProgressBar from '../ProgressBar'
import { actions as testActions } from '../../store/test'

import styles from './index.module.css'

const cx = classnames.bind(styles)

export default function Header() {
  const { stage, testType } = useSelector(state => state.app)
  const {
    preWord,
    nextWord,
    count,
    totalCount,
    runtime,
    showAnwser
  } = useSelector(state => state.test)
  const { range = [] } = runtime || {}
  const dispatch = useDispatch()

  const handleSwitch = () => {
    dispatch(testActions.setShowAnswer(!showAnwser))
  }
  const preLetter = (preWord && preWord.word) || ''
  const nextLetter = (nextWord && nextWord.word) || ''
  return (
    <div>
      <div className={styles.header}>
        <div className={styles.range}>
          {range.length > 0 ? `预计词汇量：${range[0]} ~ ${range[1]}` : ''}
        </div>
        {stage === 1 && (
          <div className={styles.switchCntr}>
            <span>显示答案</span>
            <div onClick={handleSwitch}>
              <div className={cx('switch', showAnwser ? 'open' : 'close')}>
                <div
                  className={cx(
                    'switchBtn',
                    showAnwser ? 'switchBtnOpen' : 'switchBtnClose'
                  )}
                ></div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ProgressBar current={count} total={totalCount} />
      {testType !== 2 && (
        <div className={styles.tipWord}>
          <span>{preLetter}</span>
          <span>{nextLetter}</span>
        </div>
      )}
    </div>
  )
}

Header.propTypes = {
  variant: string
}
